import { render, staticRenderFns } from "./TradeTicketPriceSection.vue?vue&type=template&id=408a1ae2&scoped=true&"
import script from "./TradeTicketPriceSection.vue?vue&type=script&lang=ts&"
export * from "./TradeTicketPriceSection.vue?vue&type=script&lang=ts&"
import style0 from "./TradeTicketPriceSection.vue?vue&type=style&index=0&id=408a1ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408a1ae2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VProgressCircular,VRow,VSelect,VTextField})
